import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { instance2 } from "App/constants";
import { defaultToastError, today, toUTCFormat } from "App/utils/helpers";
import React from "react";
import { useState } from "react";

function ModalNomorAntrian({ setShowModal, showModal, formData, setFormData }) {
  const [antrianID, setAntrianID] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await validasiAntrianID(antrianID);
    if (response.state) {
      setShowModal(false);
      setFormData({
        ...formData,
        id_antrian_loket: response.data.id,
        tanggal_antrianloket: response.data.date,
        tanggal_antrianloket_proses: toUTCFormat(today(true)),
        loket_antriantype_code: response.data.antriantype_code,
        loket_antrianno: response.data.antrianno,
      });
    } else {
      defaultToastError(response.message);
    }
  };

  if (showModal) {
    return (
      <Modal
        title={"SCAN ATAU MASUKAN ID ANTRIAN"}
        show={setShowModal}
        width='60%'>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Grid container>
            <Grid item sm={12}>
              <InputTextMaster
                name='id_antrian_loket'
                label='ID ANTRIAN LOKET'
                id='id_antrian_loket'
                type='text'
                placeholder='ID Antrian Loket'
                autoFocus={true}
                onChange={(e) => setAntrianID(e.target.value)}
                style={{
                  padding: "0.5rem 1rem",
                  fontSize: "12px",
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"submit"}
              style={{
                padding: "0.8rem",
                display: "flex",
                justifyContent: "center",
                fontSize: "14px",
              }}
              color={"green"}
              name={"Lanjutkan"}
              size='lg'
            />
            <MasterButton
              className={"w-full text-center mt-05"}
              type={"button"}
              style={{
                padding: "0.8rem",
                display: "flex",
                justifyContent: "center",
                fontSize: "14px",
              }}
              color={"secondary"}
              name={"Lanjutkan Tanpa Antrian"}
              onClick={() => setShowModal(false)}
              size='lg'
            />
          </Grid>
        </form>
      </Modal>
    );
  } else {
    return <></>;
  }
}

const validasiAntrianID = async (idAntrian) => {
  try {
    const response = await instance2.get(
      `/antrian/get-antrian-loket-byid?id_antrian=${idAntrian}`
    );

    return {
      state: true,
      data: response.data.body,
      message: "success",
    };
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export default ModalNomorAntrian;
